module.exports = __webpack_public_path__ + "static/media/es-flag.22077a59.png";